import React from 'react';

function EmailForm() {
  return (
    <>
      <div className="mt-10 lg:mt-16 rounded h-3/5 md:h-3/4 w-full md:w-10/12 max-w-screen-xl flex justify-center">
        <form
          target="_blank"
          action="https://formsubmit.co/17d0813f59b6e9aa8480be2ca97480b4"
          method="POST"
          className="sm:w-108 md:w-112 lg:w-120 2xl:w-130"
        >
          <div>
            <input
              type="text"
              name="name"
              className="w-full h-10 lg:h-12 rounded px-3 focus:outline outline-4 outline-lightGreen bg-zinc-800 text-slate-50 placeholder-slate-50"
              placeholder="Your Full Name..."
              required
            />
          </div>
          <div className="my-5">
            <input
              type="email"
              name="email"
              className="w-full h-10 lg:h-12 rounded px-3 focus:outline outline-4 outline-lightGreen bg-zinc-800 text-slate-50 placeholder-slate-50"
              placeholder="Your Email Address..."
              required
            />
          </div>
          <div>
            <input
              type="hidden"
              name="_subject"
              value="New email from portfolio!"
            />
          </div>
          <div className="">
            <textarea
              placeholder="Your Message..."
              className="w-full focus:outline outline-4 outline-lightGreen bg-zinc-800 text-slate-50 h-44 lg:h-56 2xl:h-64 resize-none rounded p-3 placeholder-slate-50"
              name="message"
              required
            />
          </div>
          <div className="flex justify-center my-4">
            <button
              type="submit"
              className="bg-lightGreen hover:bg-emerald-400 text-zinc-900 rounded-2xl h-10 w-1/2 sm:w-1/3 2xl:w-1/4 font-semibold active:translate-y-2 transition duration-200"
            >
              Send Message
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default EmailForm;
